import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `<se-po-add-guardian>
</se-po-add-guardian>`

const exampleTypescript = `
import { Component, ViewChild } from '@angular/core'
import { AddGuardianComponent } from '@se-po/shared-ui-add-guardian'

export class AddGuardianDocComponent {
  @ViewChild('addGuardian') public addGuardian: AddGuardianComponent
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-add-guardian-example',
  template,
  styleUrls: ['./add-guardian-docs.component.scss'],
  standalone: false,
})
export class AddGuardianExampleComponent extends SeFeDocsExampleComponent {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
}
